import { Component } from '@angular/core';
import { BaseComponent } from './base-component.component';
import { BsModalService } from 'ngx-bootstrap/modal';
import { NgxSpinnerService } from 'ngx-spinner';
import { ValidationHandlerService } from '../../services/validation-handler.service';

@Component({
    template: ''
})
export abstract class ListBaseComponent extends BaseComponent {

    constructor(
        protected override spinnerService: NgxSpinnerService,
        protected override modalService: BsModalService,
        protected override validationHandlerService: ValidationHandlerService,
    ) {
        super(spinnerService, modalService, validationHandlerService);
    }

}
